import { Container, ContainerSuccess } from './styles'
import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";


export function Form() {
  const form = useRef();
  const [emailSent, setEmailSent] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_cthp8xd",
        "template_gt90bno",
        form.current,
        "EH5XM71TgfKiW1cIq"
      )
      .then(
        (result) => {
          
          setEmailSent(true);
          form.current.reset();
          
        },
        (error) => {
          window.alert("Error sending email. Please try again later.");
        }
      );
  };

  if (emailSent) {
    return (
      <ContainerSuccess>
        <h3>Email sent successfully</h3>
        <button
          onClick={() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            setEmailSent(false);
          }}
        >
          Back to the top
        </button>
      </ContainerSuccess>
    );
  }

  return (
    <Container>
       <h2>Get in touch using the form below</h2>
      <form ref={form} onSubmit={sendEmail}>
        <input
          placeholder="Email"
          id="email"
          type="email"
          name="user_email"
          required
        />
        <textarea 
          required
          placeholder="Leave your message"
          id="message" 
          name="message" />
        <button type="submit" value="Send">
          Submit
        </button>
      </form>
    </Container>
  );
};


